import React from "react";
import AllCars from "../AllCars/AllCars";

const Inventories = () => {
  return (
    <div>
      <AllCars></AllCars>
    </div>
  );
};

export default Inventories;
